module.exports = __webpack_public_path__ + "img/thumbnail_BengalTiger_j_erythristic.c6480cf1.png";